import { Flex, FlexProps, Skeleton } from "@chakra-ui/react";
import { useController } from "react-hook-form";
import NumberInput from "components/Shared/Forms/NumberInput";
import {
  BIG_PINK_INPUT_PROPS,
  InputComponentProps,
} from "./pricingCalculatorUtils";

type Props = FlexProps & InputComponentProps;

export default function PricingCurrencyInput({
  formContext,
  loading,
  name,
  ...rest
}: Props) {
  const { control } = formContext;
  const { field } = useController({ name, control });
  return (
    <Flex justifyContent="flex-end" {...rest}>
      <Skeleton isLoaded={!loading} maxWidth="10em" borderRadius={10}>
        <NumberInput
          {...field}
          {...BIG_PINK_INPUT_PROPS}
          textAlign="right"
          prefix="$"
          decimalScale={2}
          fixedDecimalScale
          allowNegative={false}
          max={10000}
          step={0.1}
        />
      </Skeleton>
    </Flex>
  );
}
